function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M24 1.323v21.348c0 .734-.595 1.324-1.323 1.324h-6.118v-9.29h3.118l.466-3.621h-3.59V8.77c0-1.05.29-1.763 1.795-1.763h1.918v-3.24a25.785 25.785 0 0 0-2.796-.146c-2.765 0-4.661 1.688-4.661 4.79v2.673H9.68v3.621h3.129V24H1.323A1.326 1.326 0 0 1 0 22.677V1.323C0 .595.595 0 1.323 0h21.348C23.405 0 24 .595 24 1.323z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/facebook.571e5bc2.svg";
export { SvgComponent as ReactComponent };